import { IFile } from '../shared-types.js';
import { LocationType } from './enums.js';

export interface IScheduledEventsMap {
  [key: string]: IScheduledEvent;
}

export enum EventBookingStatus {
  REQUESTED = 'Requested',
  BOOKED = 'Booked',
  CANCELED = 'Canceled',
}

export enum EventSystemStatus {
  PASSED = 'PASSED',
  FAILED = 'FAILED',
  RESIT = 'RESIT',
  DELETED = 'DELETED',
}

export enum EventInfoStatus {
  INVITED = 'INVITED',
  BOOKED = 'BOOKED',
  PASSED = 'PASSED',
  FAILED = 'FAILED',
  RESIT = 'RESIT',
  NONE = 'NONE',
}

export interface IScheduledEvent {
  id?: string;
  bookingStatus: EventBookingStatus;
  systemStatus?: EventSystemStatus;
  infoStatus?: EventInfoStatus;
  startDate?: number;
  endDate?: number;
  location?: IEventLocation;
  fileNames?: string[]; // TODO - refactor out after STM-392
  files?: Array<IFile>;
  signedUrls?: string[];
  isProcessingPdf?: boolean;

  inviteeId?: string;
  additionalQuestions?: Array<IInviteeQuestions>;

  rescheduleUrl?: string;
  cancelUrl?: string;

  note?: string; // request new interview action
  actionReason?: string; // cancel, resit or fail action
}

export interface IEventLocation {
  type: LocationType;
  location?: string; // InPersonMeeting, OutboundCall, InboundCall, CustomLocation, InviteeSpecifiedLocation
  joinUrl?: string; // for conference: Google, Zoom, GoToMeeting, MicrosoftTeams
  metadata?: IZoomConferenceData | IGoToMeetingConferenceData | IMicrosoftTeamsConferenceData;
}

export interface IZoomConferenceData {
  id: string;
  password: string;

  // Global Access Dial-in Numbers
  phoneNumber?: string;
  countryCode?: string;
  country?: string;
  city?: string;
  type?: string;

  // International Dial-in Numbers URL
  intlNumbersUrl?: string;
}

export interface IGoToMeetingConferenceData {
  id: string;
  conferenceCallInfo?: string;
}

export interface IMicrosoftTeamsConferenceData {
  id: string;

  // Audio Conferencing
  audioConferenceId?: string;
  dialinUrl?: string;
  tollNumber?: string;
}

export interface IInviteeQuestions {
  question: string;
  answer: string;
}

/**
 * A data transfer object for EventTypeConfig from region-config
 */
export interface ICalendlyEventTypeConfigDto {
  id: string | null;
  schedulingUrl?: string;
  name?: string;
  description?: string;
}

export interface ICalendlyEvent {
  eventType: string;
  schedulingUrl: string;
  name: string;
  description: string;
  scheduledEvents: IScheduledEventsMap;
  manualAssign?: boolean;
  utmKey?: string;
  hashTimestamp?: number;
}

export interface ISummaryCalendlyEvent {
  eventType: string;
  eventKey: string;
  name: string;
  bookingStatus: EventBookingStatus;
  systemStatus?: EventSystemStatus;
  infoStatus?: EventInfoStatus;
  startDate?: number;
  endDate?: number;
  cancelUrl?: string;
  hashTimestamp?: number;
  manualAssign?: boolean;
}

export interface IFormattedEventTypeDate {
  date: string;
  startTime: string;
  endTime: string;
  tz: string;
}

export * from './enums.js';
